import { render, staticRenderFns } from "./wxlogin2.vue?vue&type=template&id=e67448e4&scoped=true&"
import script from "./wxlogin2.vue?vue&type=script&lang=js&"
export * from "./wxlogin2.vue?vue&type=script&lang=js&"
import style0 from "./wxlogin2.vue?vue&type=style&index=0&id=e67448e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e67448e4",
  null
  
)

export default component.exports